/**
 * 학원 사진 전체보기 (Learns 스타일)
 * /app/academy/:id/photos
 *
 * 학원명 + promoPhotos[] 세로 리스트 (라벨 있으면 사진 위에 표시)
 * AppShell 풀스크린 안에서 동작 (헤더·풋바 숨김)
 */
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoArrowBack } from 'react-icons/io5';
import academyService from '../../services/academyService';
import BrandLoader from '../../components/common/BrandLoader';

const AcademyPhotosPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [academy, setAcademy] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const a = await academyService.getAcademy(id);
    setAcademy(a);
    setLoading(false);
  }, [id]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <BrandLoader fullscreen />;
  if (!academy) return <Center>학원을 찾을 수 없어요.</Center>;

  const photos = (academy.promoPhotos || [])
    .map((p) => (typeof p === 'string' ? { url: p } : p))
    .filter((p) => p?.url);
  if (photos.length === 0 && academy.photoUrl) photos.push({ url: academy.photoUrl });

  return (
    <Wrap>
      <Top>
        <BackBtn type="button" onClick={() => navigate(-1)}><IoArrowBack size={22} /></BackBtn>
        <TopTitle>{academy.name}</TopTitle>
      </Top>

      <List>
        {photos.length === 0 ? (
          <Empty>등록된 사진이 없어요.</Empty>
        ) : (
          photos.map((p, i) => (
            <Card key={i}>
              {p.label && <Label>{p.label}</Label>}
              <Img src={p.url} alt={p.label || `사진 ${i + 1}`} />
            </Card>
          ))
        )}
      </List>
    </Wrap>
  );
};

export default AcademyPhotosPage;

const Wrap = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 12px 10px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #F0F1F4;
`;

const BackBtn = styled.button`
  background: none;
  display: flex;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const TopTitle = styled.p`
  font-size: 17px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const List = styled.div`
  padding: 14px 16px 30px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.p`
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.hint};
`;

const Img = styled.img`
  width: 100%;
  border-radius: 12px;
  display: block;
  background: #EDEFF3;
`;

const Empty = styled.p`
  text-align: center;
  padding: 60px 0;
  color: ${({ theme }) => theme.colors.text.hint};
`;

const Center = styled.p`
  text-align: center;
  padding: 80px 0;
  color: ${({ theme }) => theme.colors.text.hint};
`;
